module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper"
  }, [_c('HTMLHeader'), _vm._v(" "), _c('section', {
    staticClass: "mainpage"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), (this.$root.user == '') ? _c('div', {
    staticClass: "col-sm-offset-1 col-sm-5"
  }, [_c('h4', [_vm._v("Bejelentkezés")]), _vm._v(" "), _c('p', [_vm._v("Az oldalra az uni.sze.hu oldalon érvényes felhasználónevével és jelszavával tud bejelentkezni.")]), _vm._v(" "), _c('a', {
    staticClass: "button",
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": this.$root.openLoginPopup
    }
  }, [_vm._v("Belépés")])]) : _vm._e(), _vm._v(" "), (this.$root.user != '') ? _c('div', {
    staticClass: "col-sm-offset-1 col-sm-5"
  }, [_c('h4', [_vm._v("Kijelentkezés")]), _vm._v(" "), _c('a', {
    staticClass: "button",
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": this.$root.logout
    }
  }, [_vm._v("Kilépés")])]) : _vm._e()])])]), _vm._v(" "), _c('HTMLFooter'), _vm._v(" "), _c('ProfileMenu')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('h3', [_vm._v("\n            Üdvözöljük\n            "), _c('span', [_vm._v("Köszöntjük a Széchenyi István Egyetem rendszerében")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-6"
  }, [_c('p', [_vm._v("A Kiválósági Támogatási Rendszer a különböző egyetemi szervezetek által kezelt ösztöndíj-pályázatok és támogatási lehetőségek közös felületen való elérését biztosítja.")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6798b239"}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/home.vue
// module id = 384
// module chunks = 0